document.addEventListener('DOMContentLoaded', function () {
    if (typeof loginWidgetData === 'undefined') {
        return;
    }
    
    jQuery(document).ready(function ($) {
        const loginWidget = (function () {
            const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@#$%^&*!]{8,}$/;

            const selectors = {
                stepPhone: '#step-phone',
                stepEmailLogin: '#step-email-login',
                stepForgotPassword: '#step-forgot-password',
                stepResetPassword: '#step-reset-pass',
                stepForgotPasswordByPhone: '#step-forgot-password-by-phone',
                stepOtp: '#step-otp',
                stepRegister: '#step-register',
                sendOtpButton: '#send-otp',
                verifyOtpButton: '#verify-otp',
                resendOtpButton: '#resend-otp',
                loginEmailButton: '#login-email',
                forgotPasswordButton: '#forgot-password-submit',
                forgotPasswordButtonPhone: '#forgot-password-submit-phone',
                registerAccountFirst: '#register-account-first',
                registerAccountSecond: '#register-account-second',
                submitRegister: '#submit-register',
                agreeTermsCheckbox: '#agree-terms',
                resetPassButton: '#reset-pass-btn',
                forgotPasswordLink: '#forgot-password-link',
                forgotPasswordPhone: '#forgot-password-phone',
                backToLoginLink: '#back-to-login-link',
                backToPhoneFromOtp: '.back-to-phone',
                backToEmailFromForgot: '#back-to-email-login-form-forgot',
                backToEmailFromForgotPhone: '#back-to-email-login-form-forgot-phone',
                backToLoginFromRegister: '#back-to-login-from-register',
                backToLoginPhoneFromRegister: '#back-to-login-phone-from-register',
                loginWithEmailLink: '#login-with-email',
                backToEmailFromPhone: '#back-to-email-login',
                phoneInput: '#phone',
                otpInputs: '#step-otp input',
                emailInput: '#email-login',
                passwordInput: '#password',
                forgotEmailInput: '#forgot-email',
                forgotPhoneInput: '#forgot-phone',
                timerCountdown: '#timer-countdown',
                resendTimer: '#resend-timer',

                // reCAPTCHA containers (unique IDs)
                phoneCaptchaContainer: '#phone-captcha-container',
                emailCaptchaContainer: '#email-captcha-container',
                forgotCaptchaContainer: '#forgot-captcha-container',
                registerCaptchaContainer: '#register-captcha-container',
                // 2FA
                twoFASection: "#wordfence-2fa-section",
                twoFACode: '#2fa-code',
                submit2FA: '#submit-2fa',
            };

            let countdownInterval;
            const MAX_RESEND_ATTEMPTS = 3;
            let recaptchaReady = false;
            
            const init = function () {
                bindEvents();
                phoneTyping();
                
                if (loginWidgetData.recaptchaEnable) {
                    waitForRecaptcha();
                }
            };


            const waitForRecaptcha = function () {
            if (typeof grecaptcha !== 'undefined' && typeof grecaptcha.ready === 'function') {
            grecaptcha.ready(() => {
            recaptchaReady = true;
            // console.log('reCAPTCHA v3 ready');
            });
            } else {
            setTimeout(waitForRecaptcha, 100);
            }
            };

            const checkCaptcha = function (action) {
            return new Promise((resolve, reject) => {
            if (!wooli_data.helpers.recaptchaEnable) {
            resolve('');
            return;
            }
            if (!recaptchaReady) {
                showError(wooli_data.translations.captchaNotLoaded);
           
            reject(new Error('reCAPTCHA not ready'));
            return;
            }
            grecaptcha.execute(wooli_data.helpers.recaptchaSiteKey, { action: action })
            .then(function (token) {
                if (!token) {
                    showError(wooli_data.translations.captchaRequired);

                    reject(new Error('No reCAPTCHA token'));
                } else {
                    resolve(token);
                }
            })
            .catch(error => {
                console.error('reCAPTCHA execute error:', error);
                if (error.message.includes('score') || error.message.includes('clients')) {
                    renderRecaptchaV2(action).then(resolve).catch(reject);
                } else {
                    reject(error);
                }
            });
            });
            };

            const renderRecaptchaV2 = function (action) {
            return new Promise((resolve, reject) => {
            const containerId = `${action}-captcha-container`;
            let $container = $(`#${containerId}`);
            if (!$container.length) {
            $container = $('<div>').attr('id', containerId).appendTo('body').addClass('hidden');
            }
            $container.removeClass('hidden');
            const widgetId = grecaptcha.render(containerId, {
            sitekey: wooli_data.helpers.recaptchaSiteKey,
            callback: function (token) {
                $container.addClass('hidden');
                resolve(token);
            },
            'error-callback': function () {
                reject(new Error('reCAPTCHA v2 failed'));
            }
            });
            });
            };

            
            const bindEvents = function () {
                $(selectors.sendOtpButton).on('click', sendOtp);
                $(selectors.verifyOtpButton).on('click', verifyOtp);
                $(selectors.resendOtpButton).on('click', resendOtp);
                $(selectors.loginEmailButton).on('click', loginEmail);
                $(selectors.submit2FA).on('click', loginEmail);
                $(selectors.submitRegister).on('click', register);
                $(selectors.forgotPasswordButton).on('click', forgotPassword);
                $(selectors.forgotPasswordButtonPhone).on('click', forgotPasswordByPhone);
                $(selectors.forgotPasswordLink).on('click', showForgotPassword);
                $(selectors.forgotPasswordPhone).on('click', showForgotPasswordByPhone);
                $(selectors.resetPassButton).on('click', resetPass);
                $(selectors.loginWithEmailLink).on('click', showEmailLoginForm);
                $(selectors.registerAccountFirst).on('click', function (e) {
                    e.preventDefault();
                    showRegisterForm();
                    $(selectors.backToLoginFromRegister).addClass('hidden');
                    $(selectors.backToLoginPhoneFromRegister).removeClass('hidden');
                });
                $(selectors.registerAccountSecond).on('click', function (e) {
                    e.preventDefault();
                    showRegisterForm();
                    $(selectors.backToLoginFromRegister).removeClass('hidden');
                    $(selectors.backToLoginPhoneFromRegister).addClass('hidden');
                });
                $(selectors.backToLoginFromRegister).on('click', showLoginForm);
                $(selectors.backToLoginPhoneFromRegister).on('click', showPhoneForm);
                $(selectors.backToLoginLink).on('click', showLoginForm);
                $(selectors.backToPhoneFromOtp).on('click', showPhoneForm);
                $(selectors.backToEmailFromForgot).on('click', showEmailLoginForm);
                $(selectors.backToEmailFromForgotPhone).on('click', showPhoneForm);
                $(selectors.otpInputs).on('input', handleOtpInput);
                $(selectors.otpInputs).on('keydown', handleOtpKeyDown);
                $(selectors.backToEmailFromPhone).on('click', showEmailLoginForm);
            };

            const sendOtp = function (e) {
                e.preventDefault();
                const phone = $(selectors.phoneInput).val().trim();
                if (!validatePhone(phone)) {
                    Swal.fire({
                        icon: 'error',
                        title: `<span class="swal-title-custom">${loginWidgetData.translations.invalidPhone}</span>`,
                        customClass: {
                            popup: 'login-popup',
                            confirmButton: 'swal-confirm-btn',
                            cancelButton: 'swal-cancel-btn'
                        },
                    });
                    return;
                }
                checkCaptcha('phone').then(captcha => {
                    $.ajax({
                        url: loginWidgetData.ajaxUrl,
                        method: 'POST',
                        data: {
                            action: 'send_otp',
                            security: loginWidgetData.nonce,
                            phone: phone,
                            ...(loginWidgetData.recaptchaEnable && { captcha })
                        },
                        beforeSend: function () {
                            $(selectors.sendOtpButton).prop('disabled', true);
                        },
                        success: function (response) {
                            if (response.success) {
                                showOtpForm(phone);
                                startCountdown(loginWidgetData.otpTimer);
                            } else {
                                showError(response.data.message || loginWidgetData.translations.otpVerificationError);

                            }
                        },
                        error: function () {
                            showError(loginWidgetData.translations.ajaxError);

                        },
                        complete: function () {
                            $(selectors.sendOtpButton).prop('disabled', false);
                        }
                    });
                }).catch(error => console.error('Captcha error:', error));
            };

            const verifyOtp = function (e) {
                e.preventDefault();
                const phone = $(selectors.stepOtp).data('phone');
                const action = $(selectors.stepOtp).data('action');
                const otp = getOtpInput();

                if (!otp || otp.length !== 6) {
                    showError(loginWidgetData.translations.invalidOtp);
                    return;
                }

                $.ajax({
                    url: loginWidgetData.ajaxUrl,
                    method: 'POST',
                    data: {
                        action: 'verify_otp',
                        security: loginWidgetData.nonce,
                        phone: phone,
                        otp: otp,
                    },
                    beforeSend: function () {
                        $(selectors.verifyOtpButton).prop('disabled', true);
                    },
                    success: function (response) {
                        if (response.success) {
                            if (action === 'login') {
                                handleUserAuthentication(phone);
                            } else if (action === 'forgot') {
                                showResetPassword(phone);
                            }
                        } else {
                            showError(response.data.message || loginWidgetData.translations.otpVerificationError);
                         
                        }
                    },
                    error: function () {
                        showError(loginWidgetData.translations.ajaxError);
                    },
                    complete: function () {
                        $(selectors.verifyOtpButton).prop('disabled', false);
                    }
                });
            };

            const resendOtp = function (e) {
                e.preventDefault();
                const phone = $(selectors.phoneInput).val().trim();
                if (!validatePhone(phone)) {
                    showError(loginWidgetData.translations.invalidPhone);

                    return;
                }
                const attempts = getResendAttempts(phone);
                if (attempts >= MAX_RESEND_ATTEMPTS) {
                    showError(loginWidgetData.translations.resendLimitReached);

                    return;
                }

                $.ajax({
                    url: loginWidgetData.ajaxUrl,
                    method: 'POST',
                    data: {
                        action: 'resend_otp',
                        security: loginWidgetData.nonce,
                        phone: phone,
                    },
                    beforeSend: function () {
                        $(selectors.resendOtpButton).prop('disabled', true);
                    },
                    success: function (response) {
                        if (response.success) {
                            startCountdown(loginWidgetData.otpTimer);
                        } else {
                            showError(response.data.message || loginWidgetData.translations.otpVerificationError);
                           
                        }
                    },
                    error: function () {
                        showError(loginWidgetData.translations.ajaxError);
                       
                    },
                    complete: function () {
                        $(selectors.resendOtpButton).prop('disabled', false);
                    }
                });
            };

            const loginEmail = function (e) {
                e.preventDefault();
                const email = $(selectors.emailInput).val().trim();
                const password = $(selectors.passwordInput).val().trim();
                const code = $(selectors.twoFACode).length ? $(selectors.twoFACode).val().trim() : '';

                if (!validateEmail(email) || !password) {
                    showError(loginWidgetData.translations.loginFailed);

                    return;
                }
                if (!$(selectors.twoFASection).hasClass('hidden') && $(selectors.twoFACode).length && !code) {
                    showError(loginWidgetData.translations.facodeRequired);

                    return;
                }

                let captchaPromise = !code && loginWidgetData.recaptchaEnable ? checkCaptcha('email') : Promise.resolve('');
                captchaPromise.then(captcha => {
                    $.ajax({
                        url: loginWidgetData.ajaxUrl,
                        method: 'POST',
                        data: {
                            action: 'login_email',
                            security: loginWidgetData.nonce,
                            email: email,
                            password: password,
                            ...(loginWidgetData.recaptchaEnable && { captcha }),
                            code: code
                        },
                        beforeSend: function () {
                            $(selectors.loginEmailButton).prop('disabled', true);
                        },
                        success: function (response) {
                            if (response.success) {
                                if (response.data.needs_2fa) {
                                    document.querySelector(selectors.stepEmailLogin).classList.add('hidden');
                                    document.querySelector(selectors.twoFASection).classList.remove('hidden');
                                } else {
                                    waitForLogin(() => {
                                        window.location.href = response.data.redirect_url;
                                    });
                                }
                            } else {
                                showError(response.data.message || loginWidgetData.translations.loginFailed);
                              
                            }
                        },
                        error: function () {
                            showError(loginWidgetData.translations.ajaxError);
                           
                        },
                        complete: function () {
                            $(selectors.loginEmailButton).prop('disabled', false);
                        }
                    });
                }).catch(error => console.error('Captcha error:', error));
            };

            const register = function (e) {
                e.preventDefault();
                const name = document.getElementById('register-name').value.trim();
                const last_name = document.getElementById('register-last-name').value.trim();
                const username = document.getElementById('register-username').value.trim();
                const email = document.getElementById('register-email').value.trim();
                const password = document.getElementById('register-password').value.trim();
                const passwordConfirm = document.getElementById('register-password-confirm').value.trim();
                const phone = document.getElementById('register-phone').value.trim();

                let captchaPromise = loginWidgetData.recaptchaEnable ? checkCaptcha('register') : Promise.resolve('');
                captchaPromise.then(captcha => {

                    if (!name) {
                        showError(loginWidgetData.translations.nameRequired);
                        return;
                    }
                
                    if (!last_name) {
                        showError(loginWidgetData.translations.lastNameRequired);
                        return;
                    }
                
                    if (!email) {
                        showError(loginWidgetData.translations.emailRequired);
                        return;
                    }
                
                    if (!validateEmail(email)) {
                        showError(loginWidgetData.translations.emailInvalid);
                        return;
                    }
                
                    if (phone && !validatePhone(phone)) {
                        showError(loginWidgetData.translations.phoneInvalidVietnamese);
                        return;
                    }

                    if (!username) {
                        showError(loginWidgetData.translations.usernameRequired);
                        return;
                    }
                
                
                    if (!password) {
                        showError(loginWidgetData.translations.passwordRequired);
                        return;
                    }
                
                    if (!passwordRegex.test(password)) {
                        showError(loginWidgetData.translations.passwordTooShort);
                        return;
                    }
                
                    if (!passwordConfirm) {
                        showError(loginWidgetData.translations.passwordConfirmRequired);
                        return;
                    }
                
                    if (password !== passwordConfirm) {
                        showError(loginWidgetData.translations.passwordMismatch);
                        return;
                    }

                    $.ajax({
                        url: loginWidgetData.ajaxUrl,
                        method: 'POST',
                        data: {
                            action: 'register_user',
                            security: loginWidgetData.nonce,
                            name: name,
                            last_name: last_name,
                            email: email,
                            username: username,
                            password: password,
                            password_confirm: passwordConfirm,
                            phone: phone,
                            ...(loginWidgetData.recaptchaEnable && { captcha })
                        },
                        beforeSend: function () {
                            $('#submit-register').prop('disabled', true);
                        },
                        success: function (response) {
                            if (response.success) {
                                Swal.fire({
                                    icon: 'success',
                                    title: `<span class="swal-title-custom">${response.data.message}</span>`,
                                    customClass: {
                                        popup: 'login-popup',
                                        confirmButton: 'swal-confirm-btn',
                                        cancelButton: 'swal-cancel-btn'
                                    },
                                }).then(() => {
                                    window.location.href = loginWidgetData.redirectAfterRegister || '/';
                                });
                            } else {
                                showError(response.data.message);
                              
                            }
                        },
                        error: function () {
                            showError(loginWidgetData.translations.ajaxError);
                           
                        },
                        complete: function () {
                            $('#submit-register').prop('disabled', false);
                        }
                    });
                }).catch(error => console.error('Captcha error:', error));
            };

            const resetPass = function (e) {
                e.preventDefault();
                const email = $(selectors.stepResetPassword).data('email');
                const password = $(`${selectors.stepResetPassword} #reset-password`).val().trim();
                const passwordConfirm = $(`${selectors.stepResetPassword} #reset-password-confirm`).val().trim();
                const phone = $(selectors.stepResetPassword).data('phone');

                if (!password) {
                    showError(loginWidgetData.translations.passwordRequired);
                    return;
                }
            
                if (!passwordRegex.test(password)) {
                    showError(loginWidgetData.translations.passwordTooShort);
                    return;
                }
            
                if (!passwordConfirm) {
                    showError(loginWidgetData.translations.passwordConfirmRequired);
                    return;
                }
            
                if (password !== passwordConfirm) {
                    showError(loginWidgetData.translations.passwordMismatch);
                    return;
                }

                $.ajax({
                    url: loginWidgetData.ajaxUrl,
                    method: 'POST',
                    data: {
                        action: 'reset_password_user',
                        security: loginWidgetData.nonce,
                        email: email,
                        password: password,
                        password_confirm: passwordConfirm,
                        phone: phone,
                    },
                    beforeSend: function () {
                        $(`${selectors.stepResetPassword} ${selectors.resetPassButton}`).prop('disabled', true);
                    },
                    success: function (response) {
                        if (response.success) {
                            Swal.fire({
                                icon: 'success',
                                title: `<span class="swal-title-custom">${response.data.message}</span>`,
                                customClass: {
                                    popup: 'login-popup',
                                    confirmButton: 'swal-confirm-btn',
                                    cancelButton: 'swal-cancel-btn'
                                },
                            }).then(() => {
                                window.location.href = loginWidgetData.redirectAfterRegister || '/';
                            });
                        } else {
                            showError(response.data.message);
                        }
                    },
                    error: function () {
                        showError(loginWidgetData.translations.ajaxError);
                    },
                    complete: function () {
                        $(`${selectors.stepResetPassword} ${selectors.resetPassButton}`).prop('disabled', false);
                    }
                });
            };

            const forgotPassword = function (e) {
                e.preventDefault();
                const email = $(selectors.forgotEmailInput).val().trim();

                if (!email) {
                    showError(loginWidgetData.translations.emailRequired);
                    return;
                }
            
                if (!validateEmail(email)) {
                    showError(loginWidgetData.translations.emailInvalid);
                    return;
                }

                checkCaptcha('forgot').then(captcha => {
                    $.ajax({
                        url: loginWidgetData.ajaxUrl,
                        method: 'POST',
                        data: {
                            action: 'forgot_password',
                            security: loginWidgetData.nonce,
                            email: email,
                            ...(loginWidgetData.recaptchaEnable && { captcha })
                        },
                        beforeSend: function () {
                            $(selectors.forgotPasswordButton).prop('disabled', true);
                        },
                        success: function (response) {
                            if (response.success) {
                                Swal.fire({
                                    icon: 'success',
                                    title: loginWidgetData.translations.passwordResetSuccess,
                                }).then(() => {
                                    showEmailLoginForm();
                                });
                            } else {
                                showError(response.data.message || loginWidgetData.translations.passwordResetFailed);
                               
                            }
                        },
                        error: function () {
                            showError(loginWidgetData.translations.ajaxError);
                           
                        },
                        complete: function () {
                            $(selectors.forgotPasswordButton).prop('disabled', false);
                        }
                    });
                }).catch(error => console.error('Captcha error:', error));
            };

            const forgotPasswordByPhone = function (e) {
                e.preventDefault();
                const phone = $(selectors.forgotPhoneInput).val().trim();

                if (!validatePhone(phone)) {
                    showError(loginWidgetData.translations.invalidPhone);
                    return;
                }

                checkCaptcha('forgotByPhone').then(captcha => {
                    $.ajax({
                        url: loginWidgetData.ajaxUrl,
                        method: 'POST',
                        data: {
                            action: 'forgot_password_by_phone',
                            security: loginWidgetData.nonce,
                            phone: phone,
                            ...(loginWidgetData.recaptchaEnable && { captcha })
                        },
                        beforeSend: function () {
                            $(selectors.forgotPasswordButtonPhone).prop('disabled', true);
                        },
                        success: function (response) {
                            if (response.success) {
                                showOtpForm(phone, 'forgot');
                                startCountdown(loginWidgetData.otpTimer);
                            } else {
                              showError(response.data.message || loginWidgetData.translations.otpVerificationError);
                            }
                        },
                        error: function () {
                            showError(loginWidgetData.translations.ajaxError);
                        },
                        complete: function () {
                            $(selectors.forgotPasswordButtonPhone).prop('disabled', false);
                        }
                    });
                }).catch(error => console.error('Captcha error:', error));
            };

            const showForgotPassword = function (e) {
                e.preventDefault();
                hideAllSteps();
                $(selectors.stepForgotPassword).removeClass('hidden');
            };

            const showResetPassword = function (phone = null, email = null) {
                hideAllSteps();
                $('.step-reset-pass__title').text(phone);
                $(selectors.stepResetPassword).attr('data-phone', phone).removeClass('hidden');
            };

            const showForgotPasswordByPhone = function (e) {
                e.preventDefault();
                hideAllSteps();
                $(selectors.stepForgotPasswordByPhone).removeClass('hidden');
            };

            const showRegisterForm = function (e) {
                if (e) e.preventDefault();
                hideAllSteps();
                $(selectors.stepRegister).removeClass('hidden');
            };

            const showLoginForm = function (e) {
                if (e) e.preventDefault();
                hideAllSteps();
                $(selectors.stepEmailLogin).removeClass('hidden');
            };

            const showPhoneForm = function (e) {
                if (e) e.preventDefault();
                hideAllSteps();
                $(selectors.stepPhone).removeClass('hidden');
            };

            const showEmailLoginForm = function (e) {
                if (e) e.preventDefault();
                hideAllSteps();
                $(selectors.stepEmailLogin).removeClass('hidden');
                $(selectors.twoFASection).addClass('hidden');
                $(selectors.twoFACode).val('');
            };

            const showOtpForm = function (phone, action = 'login') {
                hideAllSteps();
                $(selectors.stepOtp).removeClass('hidden');
                $(`${selectors.stepOtp} .otp-inputs`).val('');
                $(`${selectors.stepOtp} .otp-inputs`).first().focus();
                $('#otp-phone').text(phone);
                $(selectors.stepOtp).attr('data-phone', phone).attr('data-action', action);
            };

            const hideAllSteps = function () {
                const steps = [
                    selectors.stepPhone,
                    selectors.stepOtp,
                    selectors.stepEmailLogin,
                    selectors.stepForgotPassword,
                    selectors.stepRegister,
                    selectors.stepForgotPasswordByPhone,
                    selectors.stepResetPassword
                ];
                steps.forEach(selector => {
                    if ($(selector).length) $(selector).addClass('hidden');
                });
            };

            const handleOtpInput = function (e) {
                const $current = $(this);
                const value = $current.val().trim();
                if (value.length === 1 && /^\d$/.test(value)) {
                    $current.val(value);
                    $current.next('input').focus();
                } else if (value.length > 1 || !/^\d$/.test(value)) {
                    $current.val('');
                }
                if ($(selectors.otpInputs).filter(function () { return $(this).val().trim() !== ''; }).length === $(selectors.otpInputs).length) {
                    verifyOtp(e);
                }
            };

            const handleOtpKeyDown = function (e) {
                const $current = $(this);
                if (e.key === 'Backspace' && $current.val() === '') {
                    $current.prev('input').focus();
                }
            };

            const getOtpInput = function () {
                let otp = '';
                $(selectors.otpInputs).each(function () {
                    otp += $(this).val().trim();
                });
                return otp;
            };

            const startCountdown = function (seconds) {
                clearInterval(countdownInterval);
                let remaining = seconds;
                $(selectors.timerCountdown).text(remaining);
                $(selectors.resendOtpButton).addClass('hidden');
                $(selectors.resendTimer).removeClass('hidden');
                countdownInterval = setInterval(() => {
                    remaining--;
                    $(selectors.timerCountdown).text(remaining);
                    if (remaining <= 0) {
                        clearInterval(countdownInterval);
                        $(selectors.resendOtpButton).removeClass('hidden');
                        $(selectors.resendTimer).addClass('hidden');
                    }
                }, 1000);
            };

            const phoneTyping = function () {
                $('#phone, #register-phone').on('input', function () {
                    let currentVal = $(this).val().replace(/[^\d]/g, '');
                    if (currentVal.length > 10) currentVal = currentVal.substring(0, 10);
                    $(this).val(currentVal);
                });
            };

            const validatePhone = function (phone) {
                return /^0[3|5|7|8|9]\d{8}$/.test(phone);
            };

            const validateEmail = function (email) {
                return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
            };

            const getResendAttempts = function (phone) {
                return localStorage.getItem(`resend_attempts_${phone}`) ? parseInt(localStorage.getItem(`resend_attempts_${phone}`), 10) : 0;
            };


            const resetResendAttempts = function () {
                const phone = $(selectors.phoneInput).val().trim();
                if (!phone) return;
                const expireTime = localStorage.getItem(`resend_attempts_time_${phone}`);
                if (expireTime && new Date().getTime() > parseInt(expireTime, 10)) {
                    localStorage.removeItem(`resend_attempts_${phone}`);
                    localStorage.removeItem(`resend_attempts_time_${phone}`);
                }
            };

            function showError(message) {
                Swal.fire({
                    icon: 'error',
                    title: `<span class="swal-title-custom">${message}</span>`,
                    customClass: {
                        popup: 'login-popup',
                        confirmButton: 'swal-confirm-btn',
                        cancelButton: 'swal-cancel-btn'
                    },
                });
            }

            setInterval(resetResendAttempts, 60 * 1000);

            const handleUserAuthentication = function (phone) {
                $.ajax({
                    url: loginWidgetData.ajaxUrl,
                    method: 'POST',
                    data: { action: 'authenticate_user_by_phone', security: loginWidgetData.nonce, phone: phone },
                    success: function (response) {
                        if (response.success) {
                            waitForLogin(() => {
                                window.location.href = response.data.redirect_url;
                            });
                        } else {
                            Swal.fire({ icon: 'error', title: response.data.message || loginWidgetData.translations.verificationFailed });
                        }
                    },
                    error: function () {
                        Swal.fire({ icon: 'error', title: loginWidgetData.translations.ajaxError });
                    }
                });
            };

            return { init: init };
        })();
        loginWidget.init();
    });
    jQuery(document).ready(function ($) {
        const agreeTermsCheckbox = $('#link-checkbox');
        const submitRegisterButton = $('#submit-register');
        submitRegisterButton.prop('disabled', true);
        agreeTermsCheckbox.on('change', function () {
            submitRegisterButton.prop('disabled', !agreeTermsCheckbox.is(':checked'));
        });

        if (typeof woodmartThemeModule.loginSidebar === 'function') {
            woodmartThemeModule.loginSidebar();
        }
        var loginFormSide = $('.login-form-side');
        var body = $('body');

        $('.login-side-opener').off('click').on('click', function (e) {
            e.preventDefault();
            showPopup();
        });

        body.on('click touchstart', '.wd-close-side, .close-side-widget, .close-popup-login', function (e) {
            e.preventDefault();
            closePopup();
        });

        $(document).on('keyup', function (e) {
            if (e.keyCode === 27) closePopup();
        });

        function showPopup() {
            loginFormSide.removeClass('opacity-0 pointer-events-none').addClass('opacity-100 pointer-events-auto wd-opened');
        }

        function closePopup() {
            loginFormSide.addClass('opacity-0 pointer-events-none').removeClass('opacity-100 pointer-events-auto wd-opened');
        }

        function togglePasswordVisibility(passwordInputId, showIconId, hideIconId) {
            const $passwordInput = $('#' + passwordInputId);
            const $showIcon = $('#' + showIconId);
            const $hideIcon = $('#' + hideIconId);
            if (!$passwordInput.length || !$showIcon.length || !$hideIcon.length) return;
            const type = $passwordInput.attr('type') === 'password' ? 'text' : 'password';
            $passwordInput.attr('type', type);
            $showIcon.toggle(type === 'password');
            $hideIcon.toggle(type !== 'password');
        }

        $('#toggle-password').on('click', function () { togglePasswordVisibility('password', 'show-password-icon', 'hide-password-icon'); });
        $('#toggle-password-1').on('click', function () { togglePasswordVisibility('register-password', 'show-password-icon-1', 'hide-password-icon-1'); });
        $('#toggle-password-2').on('click', function () { togglePasswordVisibility('register-password-confirm', 'show-password-icon-2', 'hide-password-icon-2'); });
        $('#toggle-password-3').on('click', function () { togglePasswordVisibility('reset-password', 'show-password-icon-3', 'hide-password-icon-3'); });
        $('#toggle-password-4').on('click', function () { togglePasswordVisibility('reset-password-confirm', 'show-password-icon-4', 'hide-password-icon-4'); });
    });

    const waitForLogin = (callback, timeout = 3000) => {
        const interval = 100;
        let elapsed = 0;
    
        const checkLogin = setInterval(() => {
            if (document.cookie.includes('wordpress_logged_in')) {
                clearInterval(checkLogin);
                callback();
            } else if ((elapsed += interval) >= timeout) {
                clearInterval(checkLogin);
                // fallback: cứ redirect
                callback();
            }
        }, interval);
    };
});
